import axios, { AxiosError, AxiosInstance } from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL;
const isDev = import.meta.env.VITE_DEV_MODE === 'true';

if (!baseURL) {
  throw new Error(
    'VITE_API_BASE_URL is not defined in the environment variables.'
  );
}

const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    if (isDev) {
      // console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    }
    return config;
  },
  (error) => {
    if (isDev) {
      console.error('Request error:', error);
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (isDev) {
      // console.log(`API Response: ${response.status} ${response.config.url}`);
    }
    return response;
  },
  (error: AxiosError) => {
    if (isDev) {
      console.error(
        'Response error:',
        error.response?.status,
        error.response?.data || error.message
      );
    }
    return Promise.reject(error);
  }
);

export default api;
